import React, { useState } from "react";
import { Eye, X } from "lucide-react";
import { galleryImages } from "../mock";
import { Dialog, DialogContent } from "./ui/dialog";

export default function Gallery() {
  const [open, setOpen] = useState(null);

  return (
    <section id="gallery" className="py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 reveal">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-100/70 text-[#5a9b3a] text-xs font-semibold tracking-[0.2em] uppercase">
              Our Gallery
            </div>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl md:text-5xl text-[#122b45] leading-tight">
              A peek into our <span className="text-[#ee6c4d]">joyful sessions.</span>
            </h2>
          </div>
          <p className="text-slate-600 max-w-md leading-relaxed text-sm sm:text-base">
            Smiles, sensory play, focus exercises and proud milestones — captured from our daily therapy sessions in Patna.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {galleryImages.map((src, i) => (
            <button
              key={i}
              onClick={() => setOpen(i)}
              className={`group relative rounded-2xl overflow-hidden reveal-zoom reveal-delay-${((i % 4) + 1) * 100} ${
                i === 0 ? "col-span-2 md:col-span-2 md:row-span-2 aspect-[16/11] md:aspect-auto" : "aspect-square"
              }`}
            >
              <img src={src} alt={`Nanhe Kadam Therapy Centre - therapy session ${i + 1} in Patna`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-[#122b45]/0 group-hover:bg-[#122b45]/40 transition-colors flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity bg-white text-[#122b45] rounded-full px-4 py-2 text-sm font-medium flex items-center gap-2">
                  <Eye className="w-4 h-4" /> View
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={open !== null} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-4xl bg-transparent border-0 shadow-none p-0">
          {open !== null && (
            <img src={galleryImages[open]} alt="Preview" className="w-full rounded-2xl" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
